import type { AppConfig } from '@ms-cloudpack/common-types';
import path from 'path';

/**
 * Processes the Relay configuration for the given app.
 * If Relay config is present, enable it as a capability for all packages.
 */
export function processRelayConfig(params: { appConfig: AppConfig; configPath: string }): void {
  const { appConfig, configPath } = params;
  if (!appConfig.relay) {
    return;
  }

  // Resolve rootDir relative to configPath directory.
  const rootDir = path.resolve(path.dirname(configPath), appConfig.relay.rootDir || '.');

  appConfig.packageSettings ??= [];
  appConfig.packageSettings.unshift({
    match: '*',
    bundlerCapabilities: {
      relay: {
        ...appConfig.relay,
        rootDir,
      },
    },
  });
}
